let tripleArticlePromo = {};


tripleArticlePromo.slider = function () {
    let $triplePromoSlider = $('.js-triple-promo-slider-m');

    if ($triplePromoSlider.length === 0) {
        return;
    }

    $.each($triplePromoSlider, function () {
        let $slider = $(this);

        if ($(window).width() < 768 && !$slider.hasClass('flickity-enabled')) {
            $slider.flickity({
                cellAlign: 'center',
                wrapAround: true,
                dragThreshold: 10,
                prevNextButtons: false,
                pageDots: false,
            });
        }

		if ($(window).width() >= 768 && $slider.hasClass('flickity-enabled')) {
			$slider.flickity('destroy');
		}
    });
}

tripleArticlePromo.init = function () {
    tripleArticlePromo.slider();

	window.addEventListener('resize', window.stokpress.debounce(function () {
        tripleArticlePromo.slider();
    }, 500));
}

tripleArticlePromo.init();



// WEBPACK FOOTER //
// ./scripts/components/triple-article-promo.js